var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcn24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3674 8.36762C4.70785 8.36762 5.03434 8.23238 5.27507 7.99165C5.5158 7.75092 5.65104 7.42443 5.65104 7.08398C5.65104 6.37542 5.39431 6.05707 5.13759 5.54362C4.58716 4.44329 5.02257 3.46207 6.1645 2.46289C6.42122 3.74653 7.19141 4.97882 8.21832 5.80035C9.24522 6.62187 9.75868 7.59744 9.75868 8.62435C9.75868 9.09634 9.66571 9.56372 9.48509 9.99978C9.30446 10.4358 9.03972 10.8321 8.70597 11.1658C8.37222 11.4996 7.976 11.7643 7.53993 11.9449C7.10386 12.1256 6.63649 12.2185 6.1645 12.2185C5.6925 12.2185 5.22513 12.1256 4.78906 11.9449C4.35299 11.7643 3.95678 11.4996 3.62302 11.1658C3.28927 10.8321 3.02453 10.4358 2.8439 9.99978C2.66328 9.56372 2.57031 9.09634 2.57031 8.62435C2.57031 8.03234 2.79264 7.44648 3.08377 7.08398C3.08377 7.42443 3.21901 7.75092 3.45974 7.99165C3.70046 8.23238 4.02696 8.36762 4.3674 8.36762Z",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcn24);
export default __webpack_public_path__ + "static/media/CCN24.5120613c2c6cf50c67a73d6f85b3d423.svg";
export { ForwardRef as ReactComponent };